module.exports = __webpack_public_path__ + "img/icon1.adbfc3dd.png";